module.exports = ['$http', '$q', '$rootScope', function ($http, $q, $rootScope) {
    "use strict";

    let userProfiles = {};

    class UserProfileSvc {
        get(user_id, force_reload = false) {

            var deferred = $q.defer();

            if (angular.isDefined(userProfiles[user_id]) && !force_reload) {
                deferred.resolve(userProfiles[user_id]);
            } else {
                $http({
                    method: 'GET',
                    url: `/user/${user_id}/profile/`
                }).then(function (result) {
                    userProfiles[user_id] = result.data;
                    deferred.resolve(userProfiles[user_id]);
                });
            }

            return deferred.promise;
        }

        updatePlantSettings(plant_id, user_id, settings) {
            return $http({
                method: 'PATCH',
                url: `/plant/${plant_id}/user/${user_id}/settings/`,
                data: settings
            });
        }

        tryNewDesign() {
            const body = {
                query: `mutation {
                  saveUserSettings(settingName: TRY_NEW_APP, settingValue: true) {
                    __typename
                    ... on SaveUserSettingsResponse {
                      succeeded
                    }
                    ... on ValidationError {
                      fieldErrors {
                        fieldName
                        fieldPath
                        errorDescription
                      }
                    }
                  }
                }
              `,
            };
            const options = {
                headers: {
                    'Content-Type': 'application/json'
                }
            };

            return $http.post('/graphql', body, options);
        }

        receiveNotificationsOn(plant_id) {
            const body = {
                query: `mutation {
                saveUserSettings(settingName: RECEIVE_NOTIFICATIONS, settingValue: true, plantId: %s) {
                    message
                }
            }
            ` % plant_id,
            };
            const options = {
                headers: {
                    'Content-Type': 'application/json'
                }
            };

            return $http.post('/graphql', body, options);
        }

        receiveNotificationsOff(plant_id) {
            const body = {
                query: `mutation {
                saveUserSettings(settingName: RECEIVE_NOTIFICATIONS, settingValue: false, plantId: %s) {
                    message
                }
            }
            ` % plant_id,
            };
            const options = {
                headers: {
                    'Content-Type': 'application/json'
                }
            };

            return $http.post('/graphql', body, options);
        }

    }

    return new UserProfileSvc();
}];